module.exports = __webpack_public_path__ + "static/media/image02.bde1934c.png";